import * as React from 'react';

import { Box } from '../../Common/BoxV2';
import { COLOR } from '../constants';
import { ResponsiveContainerProps } from '../components/ResponsiveContainer';
import { Rating } from '../components/Rating';
import thumbnail from '../images/ielts-book-thumbnail.png';
import {
  ThumbnailPromotionBanner,
  ThumbnailPromotionBannerProps,
} from '../ThumbnailPromotionBanner';
import { UnorderedList } from '../components/UnorderedList';

interface IeltsBookThumbnailPromotionBannerProps
  extends ResponsiveContainerProps,
    Pick<ThumbnailPromotionBannerProps, 'disabled'> {}

export const IeltsBookThumbnailPromotionBanner = (
  props: IeltsBookThumbnailPromotionBannerProps
) => {
  return (
    <ThumbnailPromotionBanner
      thumbnail={thumbnail}
      label="Reading Book"
      title="Sách Thông não IELTS Reading cùng Linear"
      renderContent={({ isMediumContainer }) => {
        return (
          <div>
            {!isMediumContainer && (
              <Box mb="12px">
                <UnorderedList
                  maxWidth={400}
                  list={['Thay đổi tư duy đọc', 'Lấy 9.0 reading', 'Không cần nhiều từ vựng']}
                />
              </Box>
            )}
            <Rating />
          </div>
        );
      }}
      action={{
        text: 'Buy Now',
        url: 'https://tiki.vn/dolbook1-thong-nao-ielts-reading-cung-linear-p95100575.html?spid=95100576',
      }}
      color={COLOR.GREEN}
      {...props}
    />
  );
};
